<template>
  <div class="userset-info">
    <div class="content">
      <div class="title">{{ $t('base_userset_info.ge_ren_jian_jie') }}</div>
      <el-form :model="form" :rules="rules" ref="form" label-position="top" style="width: 600px">
        <el-form-item :label="$t('base_userset_info.deng_lu_zhang_hao')">
          <el-input v-model="form.userName" style="width: 100%" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item :label="$t('base_userset_info.xing_ming')" prop="realName">
          <el-input v-model="form.realName" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('base_userset_info.lian_xi_dian_hua')" prop="mobile">
          <el-input v-model="form.mobile" style="width: 100%"></el-input>
        </el-form-item>
        <div class="title" style="margin-top: 40px">
          {{ $t('base_userset_info.gong_si_jian_jie') }}
        </div>
        <el-form-item :label="$t('base_userset_info.ming_cheng')">
          <el-input v-model="form.orgName" :disabled="true" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('base_userset_info.lei_xing')">
          <custom-select v-model="form.orgType" code="bas_org_type" width="100%" :disabled="true"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('base_userset_info.gai_kuang')">
          <el-input type="textarea" rows="5" v-model="form.orgShort" :disabled="true" style="width: 100%"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="btn-group">
      <el-button @click="updateUserInfo" type="primary">{{ $t('Common.com_save') }}</el-button>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  data() {
    return {
      form: {
        userCode: '',
        realName: '',
        userId: null,
        userName: '',
        mobile: '',
        orgName: '',
        orgShort: '',
        orgType: '',
      },
      organData: {},
      userInfo: {},
      orgType: {},
    };
  },
  computed: {
    rules() {
      return {
        realName: {
          required: true,
          message: this.$t('Common.com_required')
        },
      };
    },
  },
  mounted() {
    this.userInfo = this.$store.state.userInfo;
    this.form.userName = this.userInfo.userName;
    this.$setFormatData(this.form, this.userInfo);
    this.getOrganData();
    this.getDictionary('bas_org_type', (data) => {
      this.orgType = this.$transformDicValue(data.bas_org_type);
    });
    //
  },
  methods: {
    // 更新用户信息
    updateUserInfo: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$postJSON(
          apis.UserInfo,
          {
            realName: this.form.realName,
            mobile: this.form.mobile,
          },
          true
        )
          .then(() => {
            this.userInfo.userName = this.form.userName;
            this.userInfo.mobile = this.form.mobile;
            this.$store.commit('USERINFO', this.userInfo);
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
          })
          .catch(() => {});
      });
    },
    // 获取企业信息
    getOrganData: function () {
      this.$getJSON(apis.OrganUserDetail).then((res) => {
        this.organData = res.data;
        this.form.orgName = this.organData.orgName;
        this.form.orgShort = this.organData.orgShort;
        this.form.orgType = this.organData.orgType;
      });
    },
  },
};
</script>

<style lang="scss">
.userset-info {
  display: flex;
  flex-direction: column;
  height: 100%;
  .content {
    flex: 1;
    padding: 32px 24px 0;
    .title {
      font-size: 18px;
      font-weight: bold;
      height: 20px;
      font-size: 14px;
      color: rgba(73, 80, 87, 1);
      line-height: 20px;
      margin-bottom: 20px;
    }
    .user-info {
      display: flex;
      margin-top: 24px;
      margin-bottom: 34px;
      padding-bottom: 30px;
      border-bottom: 1px solid #eef2f8;

      .left {
        width: 150px;
        text-align: center;
        img {
          display: inline-block;
          width: 72px;
          height: 72px;
          border-radius: 50%;
        }
      }
      .right {
        ul li {
          line-height: 32px;
          display: flex;
          margin-bottom: 8px;
          .label {
            color: #879cbb;
            font-size: 12px;
            margin-right: 16px;
          }
        }
        .info {
          font-size: 12px;
          color: #2c405e;
          padding: 0 15px;
        }
      }
    }
    .company-info {
      display: flex;
      margin-top: 32px;
      padding-bottom: 30px;
      border-bottom: 1px solid #eef2f8;
      .left {
        width: 150px;
        text-align: center;
        img {
          display: inline-block;
          width: 72px;
          height: 72px;
          border-radius: 50%;
        }
      }
      .right {
        ul li {
          line-height: 32px;
          display: flex;
          margin-bottom: 8px;
          .label {
            color: #879cbb;
            font-size: 12px;
            margin-right: 16px;
          }
        }
        .info {
          font-size: 12px;
          color: #2c405e;
          padding: 0 15px;
        }
      }
    }
  }

  .btn-group {
    height: 60px;
    flex: 0 0 60px;
    border-top: 1px solid rgba(0, 0, 0, 0.05);
    padding: 18px 0 0 24px;
  }
}
</style>
